import React from 'react';
import { Select, MenuItem } from '@mui/material';
const QuestionSelector = ({ questions, selectedQuestionName, onQuestionChange }) => {
  // Function to format and shorten question text
  const formatQuestionText = (question, maxLength = 50) => {
    const questionText = question?.QText ?? "No text available";
    const questionNumber = question?.Q ?? "No question number";
    const text = `Q${questionNumber} ${questionText}`;
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const handleChange = (event) => {
    onQuestionChange(event.target.value);
  };

  return (
    <Select
      value={selectedQuestionName}
      onChange={handleChange}
      displayEmpty
      style={{ flex: 1 }}
      renderValue={selected => selected ? formatQuestionText(questions.find(q => q.QName === selected)) : "Select a question"}
    >
      {questions
        .filter(question => question.QName !== "INTRO" && question.QName !== "PROFOE"  && question.QName !== "VENT" )
        .map(question => (
          <MenuItem key={question.QName} value={question.QName}>
            {formatQuestionText(question)}
          </MenuItem>
      ))}
    </Select>
  );
};

export default QuestionSelector;
